const WORDS = ["Ethiopian Kitchen", "Great Cocktails", "Hookah", "Premium Drinks", "Continental Plates", "Outdoor Seating"];

export const Marquee = () => {
  const items = [...WORDS, ...WORDS];
  return (
    <section className="border-y border-[var(--br-gold)]/15 bg-[var(--br-panel)] py-6 overflow-hidden" data-testid="marquee">
      <div className="marquee-track">
        {items.map((w, i) => (
          <div key={i} className="flex items-center whitespace-nowrap">
            <span className="font-display text-3xl sm:text-4xl italic text-[var(--br-cream)] px-8">
              {w}
            </span>
            <span className="text-[var(--br-gold)] text-2xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
};
